import Slider from './code/Scripts/components/slider.vue';

export default {
  components: {
    Slider,
  },
};
